import { render, staticRenderFns } from "./DisplayCard.vue?vue&type=template&id=08f83448&scoped=true&"
import script from "./DisplayCard.vue?vue&type=script&lang=js&"
export * from "./DisplayCard.vue?vue&type=script&lang=js&"
import style0 from "./DisplayCard.vue?vue&type=style&index=0&id=08f83448&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08f83448",
  null
  
)

export default component.exports